import {
  globalpaymentsInitiatePayment,
  globalpaymentsAddressValidate,
  globalPaymentsGenerateToken,
} from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import {
  paymentTrancationSuccessHandler,
  paymentTrancationErrorHandler,
  updateClickPlaceOrderState,
} from 'common/utilities/PaymentUtils';
import { PAYMENT_TENDER_TYPES, PROD } from 'common/constants/SharedConstants';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { loadScript, redirectToPaymentFailurePage } from 'common/utilities/utils';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { APP_ENVIRONMENT, GLOBAL_PAYMENTS_3DS_FILE_URL } from '@kfc-global/react-shared/config/config.constants';
import networkConfig from '@kfc-global/react-shared/network/config';
import PAYMENT_CONSTANTS from 'organisms/Payment/constants/PaymentConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const {
  GLOBAL_PAYMENTS_CONSTANTS,
  GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS,
  GLOBAL_PAYMENTS_BROWSER_DATA_VALUES,
} = PAYMENT_CONSTANTS;

const { gloablPaymentCheckVersionUrl, gloablPayment3DSIntitiateAuthUrl } = networkConfig;

export const getGlobalPaymentsEnvironment = () => {
  return config(APP_ENVIRONMENT) === PROD
    ? GLOBAL_PAYMENTS_CONSTANTS?.GLOBAL_PAYMENTS_PRODUCTION
    : GLOBAL_PAYMENTS_CONSTANTS?.GLOBAL_PAYMENTS_SANDBOX;
};

export const getGlobalPaymentCreditCardHiddenForm = paymentCardDetails =>
  window?.GlobalPayments?.ui?.form?.({
    fields: {
      'card-number': {
        placeholder: '•••• •••• •••• ••••',
        target: '#card-number',
        value: paymentCardDetails?.cardNumber,
      },
      'card-expiration': {
        placeholder: 'MM / YYYY',
        target: '#card-expiration',
        value: paymentCardDetails?.cardExpDate,
      },
      'card-cvv': {
        placeholder: '•••',
        target: '#card-cvv',
        value: paymentCardDetails?.cardCVV,
      },
      'card-holder-name': {
        placeholder: 'xxxx xxxx',
        target: '#card-holder-name',
        value: paymentCardDetails?.cardHolderName,
      },
      submit: {
        value: 'Submit',
        target: '#payment-provider-place-order-form',
        label: translateWithI18Next(TRANSLATE_MAPPING_KEY?.PLACE_ORDER),
      },
    },
    styles: {
      'button[type=button]': {
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        height: '44px',
        color: '#FFFFFF00',
      },
      'button[type=button]:hover': {
        border: 'none',
      },
    },
  });

export const getOneTimeGlobalPaymentToken = params => {
  const { checkoutDetails, updateCheckoutDetails } = params;
  const { paymentCardDetails } = checkoutDetails;

  const globalPaymentHiddenForm = getGlobalPaymentCreditCardHiddenForm(paymentCardDetails);

  globalPaymentHiddenForm?.ready(() => {
    console.log('Global Payment Card Form Ready');
  });

  globalPaymentHiddenForm?.on('token-success', response => {
    updateCheckoutDetails({
      globalPaymentsOneTimeResponse: response,
    });
  });

  globalPaymentHiddenForm?.on('token-error', response => {
    // Show error to the consumer
    console.log('Error on Global Payment Card Form');
  });

  globalPaymentHiddenForm?.on('error', response => {
    // Show error to the consumer
    console.log('Error on Global Payment Card Form');
  });
};

export const dispatchGlobalPaymentsGenerateToken = (checkoutDetails, updateCheckoutDetails, props) => {
  checkoutDetails?.isClickAddPayment &&
    checkoutDetails?.dispatch(
      globalPaymentsGenerateToken(
        {
          tenantId: checkoutDetails?.tenantId,
          overrideRequestHeader: true,
          authToken: checkoutDetails?.RNAtoken,
          appchannel: checkoutDetails?.appchannel,
        },
        param => {
          updateCheckoutDetails({ globalPaymentsAccesstoken: param });
          window?.GlobalPayments?.configure?.({
            accessToken: param,
            env: getGlobalPaymentsEnvironment(),
          });
        },
        error => {
          redirectToPaymentFailurePage({ ...props });
        },
      ),
    );
};

export const dispatchGlobalPaymentsAddressValidateAction = (checkoutDetails, updateCheckoutDetails, props) => {
  const { dispatch, globalPaymentsAccesstoken, globalPaymentsOneTimeResponse, paymentCardDetails } = checkoutDetails;
  const { merchantId, reference } = globalPaymentsOneTimeResponse.details;

  const postData = {
    account_name: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.ACCOUNT_NAME,
    merchant_id: merchantId,
    channel: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.CHANNEL,
    capture_mode: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.CAPTURE_MODE,
    country: checkoutDetails?.countryCode,
    type: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.TYPE,
    amount: (checkoutDetails?.finalAmount * checkoutDetails?.currencyConversionFactor)?.toString(),
    currency: checkoutDetails?.currencyCode,
    reference: reference,
    payment_method: {
      first_name: checkoutDetails?.userFirstName,
      last_name: checkoutDetails?.userLastName,
      entry_mode: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.ENTRY_MODE,
      card: {
        number: paymentCardDetails?.cardNumber?.replace(/\s/g, ""),
        expiry_month: paymentCardDetails?.cardExpDate?.split?.('/')?.[0].trim?.(),
        expiry_year: paymentCardDetails?.cardExpDate?.split?.('/')?.[1]?.trim?.(),
        cvv: paymentCardDetails?.cardCVV,
        cvv_indicator: GLOBAL_PAYMENTS_ADDRESS_VALIDTAION_PAYLOAD_CONSTANTS?.CVV_INDICATOR,
        avs_address: 'Flat 456 House 123 Halifax',
        avs_postal_code: 'WB3 A21',
      },
    },
  };
  const avsPayload = {
    address: postData,
    authToken: globalPaymentsAccesstoken,
    overrideRequestHeader: true,
  };
  dispatch(
    globalpaymentsAddressValidate(
      avsPayload,
      response => {
        updateClickPlaceOrderState(checkoutDetails, updateCheckoutDetails);
      },
      error => {
        redirectToPaymentFailurePage({
          ...props,
          isCardValidateFailedScreen: checkoutDetails?.paymentCardValidateFailed,
        });
      },
    ),
  );
};

export const dispatchGlobalpaymentsInitiatePaymentAction = (props, checkoutDetails) => {
  let postData = {};
  if (checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.CREDIT_CARD) {
    const getBrowserData = window?.GlobalPayments?.ThreeDSecure?.getBrowserData();
    getBrowserData.colorDepth = GLOBAL_PAYMENTS_BROWSER_DATA_VALUES?.COLOR_DEPTH; //-- need remove
    postData = {
      token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
      accessToken: checkoutDetails?.globalPaymentsAccesstoken,
      tenderType: checkoutDetails?.tender?.name,
      orderId: checkoutDetails?.orderId,
      cardId: '',
      saveCard: false, // --- if logged in
      isStore3DS: false, //--- need to check
      threeDSServerId:
        checkoutDetails?.globalPaymentCheck3DsVersion?.enrolled === GLOBAL_PAYMENTS_CONSTANTS?.ENROLLED
          ? checkoutDetails?.globalPaymentCheck3DsVersion?.serverTransactionId
          : '',
      billingAddress: {
        streetAddress1: 'Flat 456',
        streetAddress2: 'House 123',
        streetAddress3: 'no',
        city: 'Halifax',
        postalCode: 'W5 9HR',
        countryCode: '826',
      },
      shippingAddress: {
        streetAddress1: 'Apartment 852',
        streetAddress2: 'Complex 741',
        streetAddress3: 'no',
        city: 'Chicago',
        postalCode: '5001',
        state: 'IL',
        countryCode: '840',
      },
      browserData: getBrowserData,
    };
  } else {
    postData = {
      token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
      amount: checkoutDetails?.finalAmount?.toString(),
      tenderType: checkoutDetails?.tender?.name,
      orderId: checkoutDetails?.orderId,
      customerId: '',
      paymentId: '',
    };
  }
  const initaitePaymentPayload = {
    data: postData,
    tenantId: checkoutDetails?.tenantId,
    overrideRequestHeader: true,
    authToken: checkoutDetails?.RNAtoken,
    appchannel: checkoutDetails?.appchannel,
  };

  checkoutDetails?.dispatch(
    globalpaymentsInitiatePayment(
      initaitePaymentPayload,
      response => paymentTrancationSuccessHandler(props, response),
      error => paymentTrancationErrorHandler(props, error),
    ),
  );
};

export const checkGlobalPayment3DsVersion = async (checkoutDetails, updateCheckoutDetails, props) => {
  loadScript(
    `${window.location.origin}/${config(GLOBAL_PAYMENTS_3DS_FILE_URL)}`,
    GLOBAL_PAYMENTS_CONSTANTS?.GLOBAL_PAYMENTS_3DS_SCRIPT_ID,
    async () => {
      try {
        const authToken = await AuthManager.getInstance().checkAndGetAuthToken();
        const versionCheckData = await window?.GlobalPayments?.ThreeDSecure?.checkVersion(
          gloablPaymentCheckVersionUrl?.url,
          {
            token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
            orderId: checkoutDetails?.orderId,
          },
          {
            'x-tenant-id': checkoutDetails?.tenantId,
            Authorization: 'Bearer ' + authToken,
          },
        );

        updateCheckoutDetails({ globalPaymentCheck3DsVersion: versionCheckData });
      } catch (error) {
        console.error('An error occurred', error.reasons);
        redirectToPaymentFailurePage({ ...props });
      }
    },
  );
};

export const initiateGlobalPayment3DsAuthentication = async (checkoutDetails, updateCheckoutDetails, props) => {
  const getBrowserData = window?.GlobalPayments?.ThreeDSecure?.getBrowserData();

  try {
    const authToken = await AuthManager.getInstance().checkAndGetAuthToken();
    getBrowserData.colorDepth = GLOBAL_PAYMENTS_BROWSER_DATA_VALUES?.COLOR_DEPTH; //--- color
    getBrowserData.acceptHeader = GLOBAL_PAYMENTS_BROWSER_DATA_VALUES?.ACCEPT_HEADER;

    const authenticationData = await window?.GlobalPayments?.ThreeDSecure?.initiateAuthentication(
      gloablPayment3DSIntitiateAuthUrl?.url,
      {
        token: checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference,
        orderId: checkoutDetails?.orderId,
        serverTransactionId: checkoutDetails?.globalPaymentCheck3DsVersion?.serverTransactionId,
        browserData: getBrowserData,
        billingAddress: {
          streetAddress1: 'Flat 456',
          streetAddress2: 'House 123',
          streetAddress3: 'no',
          city: 'Halifax',
          postalCode: 'W5 9HR',
          countryCode: '826',
          location: {
            latitude: 49.98846,
            longitude: -122.892003,
          },
        },
        shippingAddress: {
          streetAddress1: 'Apartment 852',
          streetAddress2: 'Complex 741',
          streetAddress3: 'no',
          city: 'Chicago',
          postalCode: '5001',
          state: 'IL',
          countryCode: '840',
        },
        challengeWindow: {
          windowSize: window?.GlobalPayments?.ThreeDSecure?.ChallengeWindowSize?.Windowed600x400,
          displayMode: 'lightbox',
        },
      },
      {
        'x-tenant-id': checkoutDetails?.tenantId,
        Authorization: 'Bearer ' + authToken,
      },
    );

    updateCheckoutDetails({ globalPaymentAuthenticationData: authenticationData });
  } catch (error) {
    console.error('An error occurred', error.reasons);
    redirectToPaymentFailurePage({ ...props });
  }
};
